export const branchSidebarTranslationEN = {
  BranchSidebar: {
    final_confirmed: 'Final Confirmed',
  },
};
